import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c0b05b90&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c0b05b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b05b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0b05b90')) {
      api.createRecord('c0b05b90', component.options)
    } else {
      api.reload('c0b05b90', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c0b05b90&scoped=true&", function () {
      api.rerender('c0b05b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4OfNen6H71g7H/JS/comp/DocBox.vue"
export default component.exports